// extracted by mini-css-extract-plugin
export default {"modal":"_2kADz","mobile":"fYTqJ","modalContent":"_3g7VB","header":"_3Wswf","subtitle":"_2pT9G","content":"_3dk56","buttonContainer":"_1JHYM","button":"_2iunH"};